<app-breadcrumb-mkt [title]="title" [routeBase]="route" />

<hr>
<div class="d-flex ">
  <button class="mx-2 btn btn-outline-primary" (click)="resetFormulario()" data-bs-toggle="modal" data-bs-target="#addCreateSucursalHorario"><i class="bi bi-plus-circle"></i> Agregar Sucursal</button>
  <button class="mx-2 btn btn-outline-primary" (click)="getAllDataSucursalHorario()"><i class="bi bi-arrow-clockwise"></i> Recargar</button>
</div>

<div class="container">
  <div class="my-5">
    <ul id="icons-list" class="row row-cols-3 row-cols-sm-4 row-cols-lg-6 row-cols-xl-8 list-unstyled list justify-content-center">
      <li *ngFor="let item of dataSucursalesHorarios" class="col mb-4 w-25 text-center" data-name="0-circle" data-tags="number numeral" data-categories="shapes" style="cursor: pointer">
        <a (click)="getDataSucursalHorarioById(item._id)" class="d-block text-body-emphasis text-decoration-none" data-bs-toggle="modal" data-bs-target="#addCreateSucursalHorario" >
          <div class="px-3 py-4 mb-2 bg-body-secondary text-center rounded">
            <i class="bi bi-geo-alt-fill"></i>
            {{item.nameSucursal}}
            <br>
            <span class="fs-6 fw-light">{{item.direccionSucursal}}</span>

          </div>
          <div class="name text-muted text-decoration-none text-center pt-1 fw-light">H.e.s: {{item.horarioEntreSemana}}</div>
          <div class="name text-muted text-decoration-none text-center pt-1 fw-light">H.s: {{item.horarioSabado}}</div>
          <div class="name text-muted text-decoration-none text-center pt-1 fw-light">H.d: {{item.horarioDomingo}}</div>
          <button (click)="setRemover(item._id)" data-bs-toggle="modal" data-bs-target="#deleteSucursal" class="  btn btn-outline-danger"><i class="bi bi-trash"></i></button>


        </a>
      </li>
    </ul>
  </div>
</div>

<app-notifications/>


<!-- Formulario eliminar -->
<div #deleteSucursalHorario class="modal fade   p-4 py-md-5" tabindex="-1" id="deleteSucursal" >
  <div class="modal-dialog modal-dialog-centered" >
    <div class="modal-content rounded-3 shadow">
      <div class="modal-body p-4 text-center">
        <h5 class="mb-0">¿Estás seguro de eliminar la sucursal?</h5>
        <p class="mb-0">Una vez realizada esta acción no se puedes deshacer.</p>
      </div>
      <div class="modal-footer flex-nowrap p-0">
        <button (click)="removeDataHorario(idRemover)" type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 border-end"><strong>Si, eliminar</strong></button>
        <button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 py-3 m-0 rounded-0" data-bs-dismiss="modal">No, volver</button>
      </div>
    </div>
  </div>
</div>
<!-- Formulario Create and Update -->
<div #addAndUpdateSucursalHorario class="modal fade" id="addCreateSucursalHorario" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Admin Sucursal</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="row g-3 needs-validation" [formGroup]="formDataForCreateSucursalHorario">

          <div class="col-md-4">
            <label for="empresaName" class="form-label">Empresa</label>
            <input formControlName="nameEmpresa" type="text" class="form-control" id="empresaName" value="" required>
            <div style="color:red;" *ngIf="formDataForCreateSucursalHorario.get('nameEmpresa')?.errors?.['required']">La empresa es obligatoria. </div>
          </div>
          <div class="col-md-8">
            <label for="validationCustom01" class="form-label">Nombre Sucursal <span class="fs-6 fw-light text-secondary">(Nombre que se muestra ejm: "Medilink Alborada")</span></label>
            <input  formControlName="nameSucursal" type="text" class="form-control" id="validationCustom01" value="" required>
            <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('nameSucursal')?.errors?.['required']">La Sucursal es obligatoria.</div>
          </div>
          <div class="col-md-4">
            <label for="validationCustom01" class="form-label">Ciudad</label>
            <input formControlName="ciudad"  type="text" class="form-control" id="" value="" required>
            <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('ciudad')?.errors?.['required']">La ciudad es obligatoria.</div>

          </div>
          <div class="col-md-8">
            <label for="direccionSucursal" class="form-label">Dirección Sucursal </label>
            <input formControlName="direccionSucursal" type="text" class="form-control" id="direccionSucursal" value="" required>
            <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('direccionSucursal')?.errors?.['required']">La dirección es obligatoria.</div>
          </div>
          <div class="col-md-12">
            <label for="linkMaps" class="form-label">Link Maps </label>
            <input formControlName="linkMaps" type="text" class="form-control" id="linkMaps" value="" required>
            <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('linkMaps')?.errors?.['required']">El link a maps es obligatorio</div>
          </div>

          <div class="col-md-12">
            <label for="" class="form-label">Horario Entre Semana <span class="text-secondary fs-6">Apertura y Cierre</span> </label>

            <div class="container g-1 d-flex">
              <input formControlName="horarioEntreSemanaEntrada" type="time" class="mx-1 form-control"  value="" required>
              <br>
              <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('horarioEntreSemanaEntrada')?.errors?.['required']">La hora es obligatoria.</div>

              <input formControlName="horarioEntreSemanaSalida" type="time" class="mx-1 form-control"  value="" required>
              <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('horarioEntreSemanaSalida')?.errors?.['required']">La hora es obligatoria.</div>

            </div>

          </div>
          <div class="col-md-12">
            <label for="" class="form-label">Horario Sabado <span class="text-secondary fs-6">Apertura y Cierre</span> </label>

            <div class="container g-1 d-flex">
              <input formControlName="horarioSabadoEntrada" type="time" class="mx-1 form-control"  value="" required>
              <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('horarioSabadoEntrada')?.errors?.['required']">La hora es obligatoria.</div>

              <input formControlName="horarioSabadoSalida" type="time" class="mx-1 form-control"  value="" required>
              <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('horarioSabadoSalida')?.errors?.['required']">La hora es obligatoria.</div>

            </div>

          </div>
          <div class="col-md-12">
            <label for="" class="form-label">Horario Domingo <span class="text-secondary fs-6">Apertura y Cierre</span> </label>

            <div class="container g-1 d-flex">
              <input formControlName="horarioDomingoEntrada" type="time" class="mx-1 form-control"  value="" required>
              <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('horarioDomingoEntrada')?.errors?.['required']">La hora es obligatoria.</div>

              <input formControlName="horarioDomingoSalida" type="time" class="mx-1 form-control"  value="" required>
              <div style="color: red;" *ngIf="formDataForCreateSucursalHorario.get('horarioDomingoSalida')?.errors?.['required']">La hora es obligatoria.</div>

            </div>

          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button (click)="resetFormulario()" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
        <button (click)="enviarData()" type="button" class="btn btn-primary">Guardar</button>
      </div>
    </div>
  </div>
</div>
